import { render, staticRenderFns } from "./Launch.vue?vue&type=template&id=4c577245&scoped=true"
import script from "./Launch.vue?vue&type=script&lang=js"
export * from "./Launch.vue?vue&type=script&lang=js"
import style0 from "./Launch.vue?vue&type=style&index=0&id=4c577245&prod&scoped=true&lang=less"
import style1 from "./Launch.vue?vue&type=style&index=1&id=4c577245&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c577245",
  null
  
)

export default component.exports